<div class="backModal enCalendar">
  <div class="close closeModal">
    <a (click)="cancelar()" title="cerrar"><span class="cross"></span><span class="sr-only">cerrar</span></a>
  </div>
  <div class="aviso">
    <div class="tituloSearch">
      {{ 'MENSAJE_REIMPRIMIR_DIA_DISTINTO' | translateV2 }}
    </div>
    <div class="faturacion-fila">
      <div class="ticket-info">
        <div class="inputControl botones">
          <button type="button" value="cancelar" class="cancelar" (click)="cancelar()">
            {{ 'CANCELAR' | translateV2 }}
          </button>
        </div>
      </div>
      <div class="ticket-info">
        <div class="inputControl botones">
          <button type="button" value="ACEPTAR" class="pagar aceptar" (click)="confirmarReimpresionDiaDistinto()">
            {{ 'ACEPTAR' | translateV2 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>